import { render, staticRenderFns } from "./NewPrivateDonationArea.vue?vue&type=template&id=1bef639e&scoped=true&"
import script from "./NewPrivateDonationArea.vue?vue&type=script&lang=ts&"
export * from "./NewPrivateDonationArea.vue?vue&type=script&lang=ts&"
import style0 from "./NewPrivateDonationArea.vue?vue&type=style&index=0&id=1bef639e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bef639e",
  null
  
)

export default component.exports